"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactHookForm = require("react-hook-form");
var _jsxRuntime = require("react/jsx-runtime");
const SelectField = ({
  id,
  value,
  onChange,
  items,
  label,
  placeholder,
  hintText,
  displayEmpty,
  disabled,
  enabledReset
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    errors
  } = (0, _reactHookForm.useFormState)();
  const hasError = Boolean(errors.existingCustomerId);
  const helperText = errors.existingCustomerId?.message?.toString() ?? null;
  const existingCustomerHelperText = helperText ?? hintText ?? '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputLabel, {
      htmlFor: id,
      children: label
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Select, {
      ...getTestIdProps('select-field'),
      fullWidth: true,
      id: id,
      error: hasError
      // Value CAN'T be undefined
      ,
      value: value ?? 0,
      displayEmpty: displayEmpty,
      disabled: disabled,
      onChange: onChange,
      children: [placeholder ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
        disabled: !enabledReset,
        value: 0,
        children: placeholder
      }) : null, items.map(({
        Id,
        Text
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
        value: Id,
        children: Text
      }, Id))]
    }), existingCustomerHelperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormHelperText, {
      children: existingCustomerHelperText
    }) : null]
  });
};
exports.SelectField = SelectField;
